import { useCartContext } from 'state/cart';

import { useCheckoutContext } from './use-checkout-context';

export const useCheckoutLoadingState = () => {
  const {
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
  } = useCheckoutContext();
  const { isOrderPriceLoading } = useCartContext();

  return {
    isOrderPriceLoading,
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
    isCheckoutLoading:
      isOrderPriceLoading ||
      isSubmittingOrder ||
      isBuildingCommitOrderPayload ||
      isLoadingPaymentMethods,
  };
};
